module.exports = __webpack_public_path__ + "img/close.66eba11d.png";